import RaTtACo_pdf from "../../../../contents/works/RaTtAco/RaTtAco.pdf";
import * as React from 'react';
export default {
  RaTtACo_pdf,
  React
};